import { TableBody, TableCell, TableRow } from '@mui/material'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React, { CSSProperties, MouseEvent, PropsWithChildren, useState } from 'react'
import RowMenu from '../table-row-menu'
import TableRowsContent from '../table-rows-content'
import { useStyles } from './styles'

interface ITableBodyContent extends PropsWithChildren {
  headCells: ITableHeadDTO[]
  rows?: any[]
  editRoutePath?: string
  detailRoutePath?: string
  handleDeleteButton?: (e: MouseEvent<any, any>, id: string) => void
  allowActions?: boolean
  onRowClick?: (row: any) => void
  getRowStyle?: (row: any) => CSSProperties | undefined
}

const TableBodyContent: React.FC<ITableBodyContent> = ({
  rows,
  children,
  headCells,
  editRoutePath,
  detailRoutePath,
  handleDeleteButton,
  allowActions = false,
  onRowClick,
  getRowStyle,
}) => {
  const [currentId, setCurrentId] = useState<string>('')

  const classes = useStyles({ color: 'red' })

  if (allowActions) {
    return <TableBody className={classes.root}>{children}</TableBody>
  }

  return (
    <TableBody className={classes.root}>
      {rows &&
        rows.map((row) => (
          <TableRow
            hover
            key={Math.random()}
            onClick={onRowClick ? () => onRowClick(row) : undefined}
            style={{
              cursor: onRowClick ? 'pointer' : undefined,
              ...(getRowStyle?.(row) ?? {}),
            }}
          >
            <TableRowsContent
              headCells={headCells}
              data={row}
            />

            <TableCell className={classes.rowTableIcon}>
              <RowMenu
                key={Math.random()}
                rowId={row.id}
                currentId={currentId}
                setCurrentId={setCurrentId}
                editRoutePath={editRoutePath}
                detailRoutePath={detailRoutePath}
                handleDeleteButton={handleDeleteButton}
              />
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  )
}

export default TableBodyContent
